import {
  GET_STATIONS_CATALOG,
  GET_STATIONS_CATALOG_SUCCESS,
  GET_STATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getStationsCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_STATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_STATIONS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_STATIONS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
